import BreathingTemplate from "./BreathingTemplate";
import JournalingTemplate from "./JournalingTemplate";
import PMRTemplate from "./PMRTemplate";
import GroundingTemplate from "./GroundingTemplate";
import VisualizationTemplate from "./VisualizationTemplate";
import CreativeExpressionTemplate from "./CreativeExpressionTemplate";
import FocusAnchoringTemplate from "./FocusAnchoringTemplate";
import FallbackTemplate from "./FallbackTemplate";

export const TEMPLATE_MAP = {
  breathing:           BreathingTemplate,
  journaling:          JournalingTemplate,
  pmr:                 PMRTemplate,
  grounding:           GroundingTemplate,
  visualization:       VisualizationTemplate,
  creative_expression: CreativeExpressionTemplate,
  focus_anchoring:     FocusAnchoringTemplate,
};

export {
  BreathingTemplate,
  JournalingTemplate,
  PMRTemplate,
  GroundingTemplate,
  VisualizationTemplate,
  CreativeExpressionTemplate,
  FocusAnchoringTemplate,
  FallbackTemplate,
};
